
import Vue from 'vue'
import { VChip, VIcon } from 'vuetify/lib'
import JcdcCard from '@/components/jcdc/JcdcCard.vue'
import JcdcFileInput from '@/components/jcdc/JcdcFileInput.vue'

type jcdcFileInput = File[] | null

export default Vue.extend({
  name: 'JcdcFileInputDragDrop',
  components: {
    VChip,
    VIcon,
    JcdcCard,
    JcdcFileInput,
  },
  props: {
    label: { type: String, required: true },
    multiple: { type: Boolean, default: false },
    accept: { type: String, default: undefined },
    hint: { type: String, default: '' },
  },
  data() {
    return {
      fileList: null as jcdcFileInput,
      inputKey: 0,
      errorMessages: undefined as string[] | undefined,
    }
  },
  computed: {
    computedHint(): string {
      return `${this.hint} ${
        this.accept ? `Only ${this.accept} file types are accepted.` : ''
      }`
    },
  },
  watch: {
    fileList(event) {
      this.errorMessages = undefined
      let emitValue
      // update the file list when the input changes
      if (event == null || undefined || event.length == 0) {
        emitValue = null
      } else if (Array.isArray(event)) {
        emitValue = [...event]
      } else {
        // set fileList to an empty array to receive file object
        emitValue = []
        emitValue?.push(event)
      }
      this.$emit('change', emitValue)
      this.inputKey++
    },
  },
  methods: {
    onClear() {
      // make sure fileList is null when input is cleared
      this.fileList = null
    },
    onClose(i) {
      // remove file from fileList when chip is closed
      this.fileList?.length == 1
        ? (this.fileList = null)
        : this.fileList?.splice(i, 1)
      // Clear errors
      if (!this.fileList) this.errorMessages = []
    },
    onDrop(event) {
      // Clear error messages
      this.errorMessages = []
      // Create a variable to hold the file array
      const fileArray = [...event.dataTransfer.files]
      // Create a variable to hold the filtered array
      let filteredArray = fileArray
      // Filter Accepted Files
      if (this.accept) {
        // Create array of accepted types
        const acceptArr = this.accept.split(',').map((i) => i.trim())
        // Filter file array by accepted types
        filteredArray = fileArray.filter(
          (el) =>
            acceptArr.includes(el.type) ||
            acceptArr.includes(el.name.slice(el.name.lastIndexOf('.')))
        )
      }
      if (filteredArray && filteredArray.length > 0) {
        // Success - show filtered files
        // Array for multiple, first item in array of single file upload
        this.fileList = this.multiple ? filteredArray : filteredArray[0]
      } else {
        // Error - show original files with error message
        this.fileList = this.multiple ? fileArray : fileArray[0]
        this.errorMessages.push(this.computedHint)
      }
    },
  },
})
